export default "__VITE_ASSET__TEuA0E9S__"